import React from 'react';

import { BodyComponent } from 'features/menu/components/product-detail/product-detail-flow/dialogs/body-component';
import { logConfirmationDialogCta } from 'features/menu/components/product-detail/product-detail-flow/dialogs/utils';

import ConfirmDialog from 'components/confirm-dialog';
import { t } from 'state/intl/translations';

interface IPickerAspectsUpdateDialog {
  showDialog: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export const PickerAspectsUpdateDialog = ({
  showDialog,
  onConfirm,
  onCancel,
}: IPickerAspectsUpdateDialog) => {
  const heading = t('productDetailResetHeading');
  const content = t('productDetailResetContent');

  const confirmLabel = t('reset');
  const cancelLabel = t('discard');

  return showDialog ? (
    <ConfirmDialog
      showDialog={showDialog}
      modalAppearanceEventMessage="Confirmation: Picker Aspect will Reset Customizations to Default"
      bodyComponent={<BodyComponent heading={heading} content={content} />}
      confirmLabel={confirmLabel}
      cancelLabel={cancelLabel}
      onConfirm={() => {
        onConfirm();
        logConfirmationDialogCta(confirmLabel);
      }}
      onCancel={() => {
        onCancel();
        logConfirmationDialogCta(cancelLabel);
      }}
    />
  ) : null;
};
